"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckboxStyles = exports.checkboxVars = exports.checkboxCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _getContrastingTextColor = require("../../utils/getContrastingTextColor");
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var checkboxCommon = exports.checkboxCommon = _commonProps.defaultCommonProps;
var checkboxVars = exports.checkboxVars = (0, _initVars.default)({
  applied: checkboxCommon,
  variables: [{
    key: "checkboxPrimary"
  }, {
    key: "checkboxColor"
  }]
});
var styles = function styles(theme) {
  var size = 18;
  return {
    variables: checkboxVars.styles,
    root: {
      position: "relative",
      display: "flex",
      fontFamily: theme.typography.fontFamily
    },
    input: {
      opacity: 0,
      zIndex: 1,
      cursor: "pointer",
      position: "absolute",
      width: "100%",
      height: "100%",
      fontFamily: "inherit",
      margin: 0,
      "&:checked + label svg": {
        backgroundColor: checkboxVars.get("checkboxColor", theme.colors.primary),
        borderColor: checkboxVars.get("checkboxColor", theme.colors.primary),
        strokeDashoffset: 0
      },
      "&:required + label": {
        "& $labelTextSpan": {
          display: "flex",
          "&:after": {
            content: '"\\002A"',
            color: theme.colors.alert,
            paddingLeft: theme.spacing.base / 2,
            paddingRight: theme.spacing.base / 2
          }
        }
      }
    },
    disabled: {
      cursor: "not-allowed",
      "&& + label": {
        "& svg": {
          borderColor: theme.colors.baseContrast030,
          boxShadow: "none"
        },
        "& $labelText": {
          color: theme.colors.baseContrast040
        }
      },
      "&:checked + label svg": {
        backgroundColor: theme.colors.baseContrast030,
        borderColor: theme.colors.baseContrast030
      }
    },
    label: {
      display: "flex",
      flexDirection: "row",
      fontFamily: "inherit",
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeight,
      lineHeight: "".concat(theme.spacing.base * 2.5, "px")
    },
    svg: {
      boxSizing: "border-box",
      width: size,
      height: size,
      minWidth: size,
      borderRadius: 3,
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: checkboxVars.get("checkboxPrimary", theme.colors.baseContrast060),
      fill: "none",
      stroke: (0, _getContrastingTextColor.getContrastingTextColorHexString)(theme.colors.primary, undefined, undefined, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD),
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: 16,
      strokeDashoffset: 16,
      transition: "all .3s ease",
      transform: "translate3d(0,0,0)",
      backgroundColor: "transparent",
      display: "flex",
      margin: 0,
      marginInlineEnd: theme.spacing.base
    },
    labelText: {
      fontFamily: "inherit",
      color: theme.colors.baseContrast070
    },
    labelTextSpan: {},
    flip: {
      flexDirection: "row-reverse",
      "& svg": {
        margin: 0,
        marginInlineStart: theme.spacing.base
      }
    },
    hint: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    description: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    }
  };
};
var useCheckboxStyles = exports.useCheckboxStyles = (0, _createUseStyles.default)(styles, {
  name: "Checkbox"
});